import { render, staticRenderFns } from "./DatePickerConfigView.vue?vue&type=template&id=5239b406&scoped=true&"
import script from "./DatePickerConfigView.vue?vue&type=script&lang=js&"
export * from "./DatePickerConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5239b406",
  null
  
)

export default component.exports